// Checked
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TablePagination,
    TableRow,
    TableHead
} from 'material-ui/Table';
import Button from 'material-ui/Button';
import Tooltip from 'material-ui/Tooltip';
import AddIcon from 'material-ui-icons/Add';
import Paper from 'material-ui/Paper';
import { FormControl } from 'material-ui/Form';
import { InputAdornment } from 'material-ui/Input';
import Search from '@material-ui/icons/Search';
import { TextField } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import _ from 'lodash';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import TablePaginationActions from '../components/TablePaginationActions';
import AuxHoc from '../hoc/AuxHoc/AuxHoc';
import {
    retrieveFonts,
    retrieveFont
} from '../actions';
import { LoaderModal } from '../components/common';

const styles = theme => ({
    fab: {
        margin: theme.spacing.unit * 2,
    },
    absolute: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 3,
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: 'auto',
        overflowY: 'auto',
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    icon: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    formControl: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    searchButton: {
        cursor: 'pointer',
    },
});

class Fonts extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleLabelDisplayedRows = this.handleLabelDisplayedRows.bind(this);

        this.state = {
            page: 1,
            search: '',
            rowsPerPage: 10
        };
    }

    componentWillMount() {
        this.props.retrieveFonts();
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    handleChangePage(event, page) {
        const { search } = this.state;
        if (event !== null) {
            this.setState({ page });
            this.props.retrieveFonts(page, search);
        }
    }

    handleChangeRowsPerPage(event) {
        this.setState({ rowsPerPage: event.target.value });
    }

    handleLabelDisplayedRows(from, to, count) {
        return `${from} - ${to} of ${count}`;
    }

    handleSearch() {
        const { search } = this.state;
        this.props.retrieveFonts(1, search);
    }

    renderContent() {
        const { classes, loading, fontsList, paginator } = this.props;
        if (_.size(fontsList) <= 0 || loading) {
            return <LoaderModal loading={loading} />;
        }
        const rowsPerPage = parseInt(paginator.per_page, 10);
        const currentPage = parseInt(paginator.current_page, 10);
        const total = parseInt(paginator.total, 10);
        const firstItem = parseInt(paginator.first_item, 10);
        const lastItem = parseInt(paginator.last_item, 10);
        return (
            <AuxHoc>
                <Paper className={classes.root}>
                    {fontsList &&
                        <div className={classes.tableWrapper}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id="search"
                                    name="search"
                                    label="Search"
                                    type="search"
                                    className={classes.textField}
                                    margin="normal"
                                    onChange={this.handleChange}
                                    onBlur={this.handleSearch}
                                    value={this.state.search}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Search
                                                    className={classes.searchButton}
                                                    onClick={this.handleSearch}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </FormControl>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell numeric>Id</TableCell>
                                        <TableCell>Family</TableCell>
                                        <TableCell>Source</TableCell>
                                        <TableCell>Format</TableCell>
                                        <TableCell>Is Active</TableCell>
                                        <TableCell>Is Plus</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        fontsList.map(font => {
                                            return (
                                                <TableRow
                                                    key={font.id}
                                                    onClick={() =>
                                                        this.props.retrieveFont(font.id, font)
                                                    }
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <TableCell numeric>{font.id}</TableCell>
                                                    <TableCell>{font.family}</TableCell>
                                                    <TableCell>{font.source}</TableCell>
                                                    <TableCell>{font.format}</TableCell>
                                                    <TableCell>
                                                        {(font.is_active === true) ?
                                                            <Check color="primary" />
                                                            :
                                                            <Close color="error" />
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {(font.plus === true) ?
                                                            <Check color="primary" />
                                                            :
                                                            <Close color="error" />
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    }
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            colSpan={8}
                                            count={total}
                                            rowsPerPage={rowsPerPage}
                                            page={currentPage}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                            rowsPerPageOptions={[10]}
                                            labelDisplayedRows={
                                                () =>
                                                    this.handleLabelDisplayedRows(firstItem, lastItem, total)
                                            }
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    }
                </Paper>
                <Tooltip title="Create a new Font">
                    <Button
                        variant="fab"
                        color="secondary"
                        className={this.props.classes.absolute}
                        onClick={() => this.props.history.push('/app/fonts/new')}
                    >
                        <AddIcon />
                    </Button>
                </Tooltip>
            </AuxHoc>
        );
    }

    render() {
        return (
            <AuxHoc>
                {this.renderContent()}
            </AuxHoc>
        );
    }
}

const mapStateToProps = ({ fonts }) => {
    const { error, loading, fontsList, paginator } = fonts;

    return { error, loading, fontsList, paginator };
};

export default connect(mapStateToProps,
    {
        retrieveFonts,
        retrieveFont
    }
)(withStyles(styles)(Fonts));
